import React from "react";
import logo from "../../../assets/logo.png";
import facebookIcon from "../../../assets/facebookIcon.png";
import twitterIcon from "../../../assets/twitterIcon.png";
import discordIcon from "../../../assets/discordIcon.png";
import Subscribe from "../../Subscribe/Subscribe";
import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.leftContainer}>
            <div className={styles.logoContainer}>
              <img src={logo} alt="logo" />
            </div>
            <p>
              The world’s first and largest digital marketplace for crypto
              collectibles and non-fungible tokens (NFTs). Buy, sell, and
              discover exclusive digital items.
            </p>
            <div className={styles.socials}>
              <img src={facebookIcon} alt="facebook" />
              <img src={twitterIcon} alt="twitter" />
              <img src={discordIcon} alt="discord" />
            </div>
          </div>

          <ul>
            <h3>Market Place</h3>
            <li>All NFTs</li>
            <li>Newest</li>
            <li>Popular</li>
            <li>Trending now</li>
          </ul>

          <ul>
            <h3>My Account</h3>
            <li>Profile</li>
            <li>Favorites</li>
            <li>My Collections</li>
            <li>Terms & condition</li>
            <li>Privacy Policy</li>
          </ul>

          <div className={styles.rightContainer}>
            <h3>Stay in the loop</h3>
            <p>
              Join our mailing list to stay in the loop with our newest feature
              releases, NFT drops, and tips and tricks for navigating NFTs.
            </p>
            <Subscribe />
          </div>
        </div>
        <div className={styles.copyright}>
          <p>Copyright © 2022</p> <img src={logo} alt="logo" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
